import React, { FC } from 'react'
import { LFModal, LFModalProps } from './LFModal'
import { LFButton, LFButtonColor, LFButtonType } from '@components/LFButton'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react'

interface LFDrawerProps extends LFModalProps {
  withApplyButton?: boolean
}

export const LFDrawer: FC<LFDrawerProps> = observer(
  ({
    children,
    onClickOutside,
    withApplyButton = true,
    width = 'w-full md:w-1/3',
    ...rest
  }) => {
    const { t } = useTranslation()

    return (
      <LFModal
        {...rest}
        onClickOutside={onClickOutside}
        width={width}
        detached={false}
      >
        {children}
        {withApplyButton ? (
          <div
            className={`
              mt-3 flex w-full justify-center
              md:hidden
            `}
          >
            <LFButton
              onClick={onClickOutside}
              color={LFButtonColor.MAIN}
              type={LFButtonType.PRIMARY}
              buttonType="button"
            >
              {t('apply')}
            </LFButton>
          </div>
        ) : null}
      </LFModal>
    )
  }
)
